export default "__VITE_ASSET__BqMuL1MN__"